// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3DMrQ","row":"styles_row__2uGMu"};